const Experience = () => {
    return (
        <div>
            <h2>Previous work experience</h2>

            <ul>
                <li>Lab Team Trainee, Airbus Helsinki, May 2024 - present</li>
                <li>Salesperson, Clas Ohlson, October 2021- December 2023</li>
                <li>Event technician, The Best Crew Ever, October 2019</li>
            </ul>

            <h2>Significant education so far</h2>

            <ul>
                <li>ICT, Bachelor of Software Engineering, Metropolia University of Applied Sciences, 2022 - present</li>
                <li>Intermediate stage technician education, the Guards band, 2021</li>
                <li>Baccalaureate, Helsinki Upper Secondary School of Media Arts, 2017 - 2020</li>
                <li>Introduction to stage technician education, Aurinkolahti Comprehensive school, 2016</li>
                <li>Introduction to robotics, Aurinkolahti Comprehensive school, 2015</li>
            </ul>
        </div>
    );
}

export default Experience;